document.addEventListener('DOMContentLoaded', function () {
  let splideInstance;

  function moveFullSlide() {
    const slider = document.querySelector('.product-main-slider .splide__list');
    const fullSlide = slider.querySelector('.product__media-item--full');

    if (fullSlide) {
      const slides = Array.from(slider.children);
      const secondSlide = slides[1];

      if (secondSlide && secondSlide !== fullSlide) {
        slider.insertBefore(fullSlide, secondSlide);
      }
    }
  }

  function initSplide() {
    if (window.innerWidth <= 767 && !splideInstance) {
      const fullWidthSeen = document.querySelector('.product-main-slider .full-width-seen');
      if (fullWidthSeen) {
        fullWidthSeen.remove();
      }

      moveFullSlide(); // Ensure the slide is in the correct position

      splideInstance = new Splide('.product-main-slider', {
        type: 'slide',
        perPage: 2,
        autoplay: false,
        arrows: false,
        gap: '8px',
        pagination: false,
        drag: true,
        swipe: true
      }).mount();

    } else if (window.innerWidth > 767 && splideInstance) {
      splideInstance.destroy();
      splideInstance = null;
    }
  }

  initSplide();
  window.addEventListener('resize', initSplide);
});



function togglePlayPause(videoId) {
  const video = document.getElementById(videoId);
  
  if (!video) {
    console.error(`Video element with id "${videoId}" not found.`);
    return;
  }

  const button = document.querySelector(`.play-pause-btn[onclick="togglePlayPause('${videoId}')"]`);
  
  if (!button) {
    console.error(`Button for video with id "${videoId}" not found.`);
    return;
  }

  const playIcon = button.querySelector('.play-icon');
  const pauseIcon = button.querySelector('.pause-icon');

  if (video.paused) {
    video.play();
    button.classList.add('active');
  } else {
    video.pause();
    button.classList.remove('active');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('video');
  videos.forEach(function(video) {
    const button = video.nextElementSibling;
    const playIcon = button.querySelector('.play-icon');
    const pauseIcon = button.querySelector('.pause-icon');

    if (video.paused) {
      button.classList.remove('active');
    } else {
      button.classList.add('active'); 
    }

    video.addEventListener('play', function() {
      button.classList.add('active'); 
    });

    video.addEventListener('pause', function() {
      button.classList.remove('active');
    });
  });
});

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]')
      };
      this.mql = window.matchMedia('(min-width: 750px)');
    }

    setActiveMedia(mediaId) {
      console.log('mediaId', mediaId);
      const activeSlide = this.elements.viewer.querySelector('.splide__slide.is-active');
      const variantImages = activeSlide.querySelectorAll('.slider_variant_image');
      if(variantImages){
      variantImages.forEach(image => image.classList.remove('show_var_image'));
      const activeVariantImage = activeSlide.querySelector(`.variant_${mediaId}`);
      if (activeVariantImage) {
        activeVariantImage.classList.add('show_var_image');
        this.playActiveMedia(activeVariantImage); // Ensure video playback if needed
      }
      this.announceLiveRegion(activeVariantImage, mediaId);
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem?.querySelector('.product__modal-opener--image img');
      if (!image) return;

      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src; // Force reload
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    }
  });
}
